import { isValidDate } from "./is-valid-date";

export function toTimeSpan(date) {
    if (!isValidDate(date)) return null;
    return date.getHours().toString().padStart(2, 0) +
        ":" +
        date.getMinutes().toString().padStart(2, 0);

}